import { useTranslation } from "next-i18next";
import PropTypes from "prop-types";
import { CheckIcon } from "@components/Icon";
import styles from "./styles/SortDropdown.module.css"

export const SortDropdown = ({ sortValues, showPanel, sortBy, setSortBy, searchView }) => {
  const { t } = useTranslation("filter");
  const onChange = (value) => {
    if (sortBy && sortBy === value) { setSortBy(null); return }
    setSortBy(value);
  }
  const clearSortBy = () => setSortBy(null)

  const containerStyles = `
    ${searchView ? styles.openContainer : styles.container}
    ${showPanel ? styles.showContainer : ""}
  `;

  const Header = () => {
    const headerStyles = `
      ${searchView ? styles.searchHeading : styles.heading}
    `;
    return (
      <header className={headerStyles}>
        {searchView && (
          <h4>{t("sort-label")}</h4>
        )}
        {!searchView && (
          <h4>{t("sort-label")}:</h4>
        )}
        {sortBy && (
          <button className={styles.reset} onClick={clearSortBy}>Reset</button>
        )}
      </header>
    );
  };

  const List = () => {
    return (
      <ul className={styles.list}>
        {sortValues.map((value, index) => (
          <ListItem key={`${value}-${index}`} value={value} />
        ))}
      </ul>
    );
  };

  const ListItem = ({ value }) => {
    return (
      <li className={styles.listItem}>
        <button className={styles.button} onClick={() => onChange(value)}>
          {t(value)}
          {sortBy === value && <CheckIcon />}
        </button>
      </li>
    );
  };

  return (
    <div className={containerStyles}>
      <Header  />
      <List />
    </div>
  );
};

SortDropdown.propTypes = {
  sortValues: PropTypes.array,
  showPanel: PropTypes.bool,
  sortBy: PropTypes.string,
  setSortBy: PropTypes.func,
};
